 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781847675026_COVER from '@/components/9781847675026_cover'
 import LOVE_1 from '@/components/love_1'
 import A781847675026_OTHER_001 from '@/components/9781847675026_other_001'
 import ALSOBY from '@/components/alsoby'
 import A781847675026_OTHER_01 from '@/components/9781847675026_other_01'
 import A781847675026_BOOKTITLEPAGE from '@/components/9781847675026_booktitlepage'
 import A781847675026_INSERTEDCOPYRIGHT from '@/components/9781847675026_insertedcopyright'
 import A781847675026_OTHER_02 from '@/components/9781847675026_other_02'
 import A781847675026_TABLEOFCONTENTS from '@/components/9781847675026_tableofcontents'
 import A781847675026_CHAPTER_01 from '@/components/9781847675026_chapter_01'
 import A781847675026_CHAPTER_02 from '@/components/9781847675026_chapter_02'
 import A781847675026_CHAPTER_03 from '@/components/9781847675026_chapter_03'
 import A781847675026_CHAPTER_04 from '@/components/9781847675026_chapter_04'
 import A781847675026_CHAPTER_05 from '@/components/9781847675026_chapter_05'
 import A781847675026_CHAPTER_06 from '@/components/9781847675026_chapter_06'
 import A781847675026_CHAPTER_07 from '@/components/9781847675026_chapter_07'
 import A781847675026_CHAPTER_08 from '@/components/9781847675026_chapter_08'
 import A781847675026_CHAPTER_09 from '@/components/9781847675026_chapter_09'
 import A781847675026_CHAPTER_10 from '@/components/9781847675026_chapter_10'
 import A781847675026_CHAPTER_11 from '@/components/9781847675026_chapter_11'
 import A781847675026_CHAPTER_12 from '@/components/9781847675026_chapter_12'
 import A781847675026_CHAPTER_13 from '@/components/9781847675026_chapter_13'
 import A781847675026_CHAPTER_14 from '@/components/9781847675026_chapter_14'
 import A781847675026_CHAPTER_15 from '@/components/9781847675026_chapter_15'
 import A781847675026_CHAPTER_16 from '@/components/9781847675026_chapter_16'
 import LOVE_2 from '@/components/love_2'
 import A781847675026_ACKNOWLEDGEMENTS from '@/components/9781847675026_acknowledgements'
 import A781847675026_CHAPTER_17 from '@/components/9781847675026_chapter_17'
 import ADS from '@/components/ads'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781847675026_tableofcontents",
 			"name" : "9781847675026_tableofcontents",
 			"component" : A781847675026_TABLEOFCONTENTS
 		},
 		{
 			"path" : "/9781847675026_chapter_01",
 			"name" : "9781847675026_chapter_01",
 			"component" : A781847675026_CHAPTER_01
 		},
 		{
 			"path" : "/9781847675026_chapter_02",
 			"name" : "9781847675026_chapter_02",
 			"component" : A781847675026_CHAPTER_02
 		},
 		{
 			"path" : "/9781847675026_chapter_03",
 			"name" : "9781847675026_chapter_03",
 			"component" : A781847675026_CHAPTER_03
 		},
 		{
 			"path" : "/9781847675026_chapter_04",
 			"name" : "9781847675026_chapter_04",
 			"component" : A781847675026_CHAPTER_04
 		},
 		{
 			"path" : "/9781847675026_chapter_05",
 			"name" : "9781847675026_chapter_05",
 			"component" : A781847675026_CHAPTER_05
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js